import { Link } from "react-router-dom";
import { ShoppingBag, Camera, Newspaper } from "lucide-react";

/**
 * Floating right rail like the reference site — quick access to Shop, Gallery, Blog.
 * Hidden on mobile (where WhatsApp button + nav are sufficient).
 */
export default function SideRail() {
  return (
    <div data-testid="side-rail" className="hidden md:flex fixed right-0 top-1/2 -translate-y-1/2 z-30 flex-col gap-px">
      <Link to="/shop" data-testid="side-rail-shop" className="group bg-[var(--pz-red)] hover:bg-[var(--pz-red-2)] text-white h-14 w-14 grid place-items-center transition-all" aria-label="Shop">
        <ShoppingBag className="h-5 w-5" />
      </Link>
      <Link to="/gallery" data-testid="side-rail-gallery" className="group bg-[var(--pz-red)] hover:bg-[var(--pz-red-2)] text-white h-14 w-14 grid place-items-center transition-all" aria-label="Gallery">
        <Camera className="h-5 w-5" />
      </Link>
      <Link to="/blog" data-testid="side-rail-blog" className="group bg-[var(--pz-red)] hover:bg-[var(--pz-red-2)] text-white h-14 w-14 grid place-items-center transition-all" aria-label="Blog">
        <Newspaper className="h-5 w-5" />
      </Link>
    </div>
  );
}
